<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title mb-0">
            {{ activeLanguageTranslations?.citationLabel }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.citationLabel }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.citationParagraphOne }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.citationParagraphTwo }}
        </div>
        <div class="static-content-paragraph">
          <span class="ct-content">
          {{ activeLanguageTranslations?.citationParagraphThree }} <a class="know-more" href="{{ activeLanguageTranslations?.link1 }}" target="_blank">{{ activeLanguageTranslations?.link1 }}</a>
          </span>
        </div>


        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph2 }}
        </div>
        <div class="static-content-paragraph">
          <span class="ct-content">
          {{ activeLanguageTranslations?.paragraph2_1 }} <a class="know-more" href="{{ activeLanguageTranslations?.link2 }}" target="_blank">{{ activeLanguageTranslations?.link2 }}</a> {{ activeLanguageTranslations?.paragraph2_2 }}
          </span>
        </div>


        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph3 }}
        </div>
        <div class="static-content-paragraph">
          <span class="ct-content">
          {{ activeLanguageTranslations?.paragraph3_1 }} <a class="know-more" href="{{ activeLanguageTranslations?.link3 }}" target="_blank">{{ activeLanguageTranslations?.link3 }}</a>
          </span>
        </div>

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
